/* eslint-disable react-hooks/exhaustive-deps, no-unused-expressions */
import { haveDatesChanged, doDatesContain } from 'lib/utils';
import { useMemo } from 'react';

interface StayDates {
  checkIn: string;
  checkOut: string;
}

interface Options {
  isValid: boolean;
  loading: boolean;
  dates: StayDates;
  originalDates: StayDates;
  unavailableDates?: StayDates;
}

export const useSubmitEnabled = ({ isValid, loading, dates, originalDates, unavailableDates }: Options) => {
  return useMemo(() => {
    if (loading) return false;
    if (!isValid) return false;
    if (!haveDatesChanged(dates, originalDates)) return false;
    if (doDatesContain(dates, unavailableDates)) return false;
    return true;
  }, [isValid, loading, dates, Object.values(originalDates), Object.values(unavailableDates || {})]);
};
